import { computed, ref } from 'vue'
import { useChangelogQuery } from '@/api/changelog'
import { getInstance } from '@/auth'

const STORAGE_KEY = 'ironsight_changelog_last_seen_id'

export function useChangelogBadge() {
  const lastSeenId = ref(localStorage.getItem(STORAGE_KEY))
  const auth = getInstance()
  const enabled = computed(() => auth?.isAuthenticated ?? false)
  const { data } = useChangelogQuery(enabled)

  const hasNewEntries = computed(() => {
    const entries = data.value
    if (!entries || entries.length === 0) return false
    return entries[0].id !== lastSeenId.value
  })

  function markAsSeen() {
    const entries = data.value
    if (!entries || entries.length === 0) return
    lastSeenId.value = entries[0].id
    localStorage.setItem(STORAGE_KEY, entries[0].id)
  }

  return { hasNewEntries, markAsSeen }
}
